import { render, staticRenderFns } from "./BlockDetailPOS.vue?vue&type=template&id=e66359a2&scoped=true&"
import script from "./BlockDetailPOS.vue?vue&type=script&lang=js&"
export * from "./BlockDetailPOS.vue?vue&type=script&lang=js&"
import style0 from "./BlockDetailPOS.vue?vue&type=style&index=0&id=e66359a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e66359a2",
  null
  
)

export default component.exports